<div fxLayout="row">
  <div fxFlex fxLayoutAlign="center center" style="margin: 12px">
    <app-isomasters-slider
      [max]="max"
      [min]="min"
      [step]="step"
      [(value)]="value"
      fxFlex
      (valueChange)="updateValue($event)"></app-isomasters-slider>
  </div>
  <div style="width: 80px; margin: 12px">
    <app-isomasters-input
      [selectId]="selectId"
      [max]="max"
      [min]="min"
      [step]="step"
      [(value)]="value"
      [type]="'number'"
      (valueChange)="updateValue($event)"></app-isomasters-input>
  </div>
  <div fxLayout="column" fxLayoutAlign="center center"><span class="very-light-text">mm</span></div>
</div>
